import axios from 'axios';
import authHeader from '../auth-header';

const NODE_ENV = process.env.NODE_ENV;
const PROTOCOL = process.env.PROTOCOL || 'http://';
const END_POINT_URL = process.env.END_POINT_URL || window.location.hostname;
const END_POINT_PORT = process.env.END_POINT_PORT || '8080';

const API_URL = NODE_ENV === 'production' ? PROTOCOL + END_POINT_URL + '/api/radar/team/' : PROTOCOL + END_POINT_URL + ':' + END_POINT_PORT + '/api/radar/team/';

class TeamRadarService {
  getTeamRadarData(teamId, seasonIds, minMax, radarId, gameIds, isRadar, url, zone, browser, metaInfo) {
    gameIds = gameIds.toString();
    let options = {
      params:{
        gameIds, url, zone, browser, metaInfo
      }
    }
    return axios.get(API_URL + teamId + "/seasons/" + seasonIds + "/min-max/" + minMax + "/radar/" + radarId + "/is-radar/" + isRadar, options);
  }
  getAvailableTeamRadarsByClient(clientId) {
    return axios.get(API_URL  + "available/radars/client/" + clientId);
  }
  getGamesOfTeamBySeasons(teamId, seasonIds){
    return axios.get(API_URL  + teamId + "/seasons/" + seasonIds);
  }

}

export default new TeamRadarService();



// WEBPACK FOOTER //
// ./src/services/team/teamRadar.service.js